var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FieldSelect',{attrs:{"state":_vm.state,"label":_vm.label,"options":_vm.options,"multiple":_vm.multiple,"disabled":_vm.disabled,"is-required":_vm.isRequired,"class-label":_vm.classLabel,"placeholder":_vm.placeholder},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }